module.exports = __webpack_public_path__ + "img/loginbg.5fcb540d.jpg";